import React from 'react'
import { useTranslation } from 'react-i18next'

import { Link } from '@ui/components/Link'

import { WalletRestrictions, isRestricted, isWalletSuspended } from '@utils/wallet.utils'

import { NameDto } from '@model/NameDto'

import { useDispatchOpenChat } from '@hooks/useDispatchOpenChat'

interface WalletRestrictionProps {
  restrictions: NameDto[] | undefined
  restrictionType?: WalletRestrictions
  onClose: () => void
}

export const WalletRestriction: React.FC<WalletRestrictionProps> = ({
  restrictions,
  restrictionType,
  onClose,
}) => {
  const { t } = useTranslation()
  const { dispatchOpenChat, isLoading: isHubSpotChatLoading } = useDispatchOpenChat()

  const handleContactSupportClick = () => {
    dispatchOpenChat()
    onClose()
  }

  if (isWalletSuspended(restrictions)) {
    return (
      <div>
        <div className='has-error'>{t('Transfers restricted for this TM Wallet')}</div>
        <div>
          {t('Please')}{' '}
          <Link onClick={handleContactSupportClick} disabled={isHubSpotChatLoading}>
            {t('Contact Support').toLowerCase()}
          </Link>{' '}
          {t('for more info.')}
        </div>
      </div>
    )
  }

  if (restrictionType && isRestricted(restrictionType, restrictions)) {
    return (
      <div>
        <div className='has-error'>{t('Temporarily restricted!')}</div>
        <div>
          {t('Please')}{' '}
          <Link onClick={handleContactSupportClick}>{t('Contact Support').toLowerCase()}</Link>{' '}
          {t('for more info.')}
        </div>
      </div>
    )
  }

  return null
}
